// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { modeTestnet as _modeTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the modeTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 919
 * Chain Name: Mode Testnet
 * Default Block Explorer: https://sepolia.explorer.mode.network
 * Default RPC URL: https://sepolia.mode.network
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { modeTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: modeTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const modeTestnet = createCommon({
	..._modeTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
